export default "__VITE_ASSET__DdRZjoRY__"